import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ACCESS_NETWORK_ROLLOUT_INLCM_6 = {
  title:
    "After the design generation is \ncomplete, it can be manually \noverridden using our tools. The \ngenerated design is downloadable in \nvarious formats, and it includes a \nGoogle Street view for location \nvisualization.",
  subtitle: "Access Network Rollout",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_321"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_319"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_2.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_digital_twin_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "160px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_06_map.png",
          imageStyle: { position: "absolute", bottom: "348px", right: "103px" },
        },
        {
          image: "ENG/INLCM/INLCM_access_net_06_popup.png",
          imageStyle: {
            position: "absolute",
            bottom: "114.63px",
            right: "720px",
          },
        },
      ]}
      pageNumber={"ENG_320"}
    />
  ),
};
